import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardDate',
  standalone: true
})
export class CardDatePipe implements PipeTransform {

  constructor(
    private readonly datePipe: DatePipe,
  ) { }


  transform(month: any, year: any): string {

    month = Number(month);
    year = Number(year);

    if (year < 100) {
      year += 2000;
    }

    const dateObject = new Date(year, (month - 1));
    const formattedDate = this.datePipe.transform(dateObject, 'MM/yyyy');
    return formattedDate!;
  }

}
